import type { ExcelTabsState } from "./types";

export interface ExcelClientUpdateBusyInput {
  /** Number of registered Excel agent or retry runs. */
  inFlightRunCount: number;
  /** Current workbook-scoped chat and continuation state. */
  tabsByWorkbook: Record<string, ExcelTabsState>;
  /** Number of unresolved native `ask_user` questions. */
  userQuestionCount: number;
}

/**
 * Reports whether reloading would interrupt Excel work or a pending decision.
 *
 * @param input - Live run, workbook-tab, and native-question state.
 * @returns `true` while any work or resumable user decision remains pending.
 * @throws Never.
 */
export function isExcelClientUpdateBusy(input: ExcelClientUpdateBusyInput): boolean {
  if (input.inFlightRunCount > 0 || input.userQuestionCount > 0) return true;

  return Object.values(input.tabsByWorkbook).some((state) =>
    state.tabs.some((tab) => Boolean(tab.isLoading || tab.pendingOperation))
  );
}
